import React from "react";
import ipecusImg from "../img/home/referencias/ipecus.svg";
import laboratorioCamussoImg from "../img/home/referencias/laboratorio.svg";
import josefinaPelayoImg from "../img/home/referencias/josefinaPelayo.svg";
import owltrackImg from "../img/home/referencias/owltrack.svg";
export const CarouselReferencias = () => {
  return (
    <div className="wrapper">
    <div className="outer">
    <div className="card-referencias" style={{ "--delay": "-1" }}>
        <div className="content">
          <div className="img">
            <img src={josefinaPelayoImg} alt="Josefina Pelayo" />
          </div>
          <div className="details">
            <span className="name">JOSEFINA PELAYO</span>
            <p>
              {" "}
              Supieron entender a la perfección lo que soñaba y lograron
              transformar mis ideas en un diseño hermoso y funcional.{" "}
            </p>
          </div>
        </div>
      </div>
      <div className="card-referencias" style={{ "--delay": "0" }}>
        <div className="content">
          <div className="img">
            <img src={laboratorioCamussoImg} alt="Laboratorio camusso" />
          </div>
          <div className="details">
            <span className="name">LABORATORIO CAMUSSO</span>
            <p>
              ¡Innovación, profesionalismo, compromiso, dedicación, calidez!
              Es un placer trabajar juntos.{" "}
            </p>
          </div>
        </div>
      </div>
      <div className="card-referencias" style={{ "--delay": "1" }}>
        <div className="content">
          <div className="img">
            <img src={josefinaPelayoImg} alt="Josefina Pelayo" />
          </div>
          <div className="details">
            <span className="name">JOSEFINA PELAYO</span>
            <p>
              {" "}
              Supieron entender a la perfección lo que soñaba y lograron
              transformar mis ideas en un diseño hermoso y funcional.{" "}
            </p>
          </div>
        </div>
      </div>
      <div className="card-referencias" style={{ "--delay": "2" }}>
        <div className="content">
          <div className="img">
            <img src={laboratorioCamussoImg} alt="Laboratorio camusso" />
          </div>
          <div className="details">
            <span className="name">LABORATORIO CAMUSSO</span>
            <p>
              ¡Innovación, profesionalismo, compromiso, dedicación, calidez!
              Es un placer trabajar juntos.{" "}
            </p>
          </div>
        </div>
      </div>
     
    </div>
  </div>
  );
};
